import styled from 'styled-components';

export const MessageContainer = styled.div`
    background-color: ${props => props.theme.whiteSmoke};
    border-radius: 10px;
    padding: 20px;
    margin-top: 25px;

    h3,
    h3:first-child {
        margin: 0 0 20px;
    }

    p + p {
        margin-top: 15px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/message/ConfirmationEbonPageMessageBlocStyle.js